module.exports = __webpack_public_path__ + "img/tb_apps.3efb7c6e.jpg";